import React from 'react'

function Hero() {
    return (
        <section className="hero relative py-20 md:pt-32">
            <picture className="pointer-events-none absolute inset-0 -z-10">
                <img src="img/gradient_dark.jpg" alt="gradient dark" className="h-full w-full" />
            </picture>
            <img src="img/patterns/pattern_donut.png" alt="pattern donut" className="absolute right-0 top-0 -z-10" />

            <div className="container">
                <div className="mx-auto max-w-2xl pt-24 text-center">
                    <h1 className="mb-6 font-display text-5xl text-white lg:text-6xl">Hello! I am <span
                        className="animate-gradient">Wajahat Rana</span>
                        <br></br>
                        Fullstack Developer and UI/UX Designer
                    </h1>
                    <p className="mx-auto mb-8 max-w-md text-lg leading-normal text-khi-50">
                        Passionate about crafting beautiful and functional websites and applications, I bring expertise in Fullstack
                        Development and UI/UX Design.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Hero